// Thin wrapper for Google Tag Manager. Pushes events onto window.dataLayer.
export function track(event, params = {}) {
  try {
    if (typeof window !== "undefined") {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event, ...params });
    }
  } catch (e) {
    // analytics must never break the app
  }
}

export const GTM_ID = "GTM-K4F64T4D";
export const CALENDLY_THANK_YOU = "https://bonzabfs.com.au/calendly-thank-you";
